import { render, staticRenderFns } from "./showTarefeList.vue?vue&type=template&id=17f8da3c&scoped=true"
import script from "./showTarefeList.vue?vue&type=script&lang=js"
export * from "./showTarefeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f8da3c",
  null
  
)

export default component.exports